import dimensions from 'shared/styles/dimensions'
import styled from 'styled-components'

import { colors } from '../../styles/colors'
import Button from '../Button'

export const Container = styled.table`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export const TableRow = styled.tr`
  background-color: ${colors.white};
  color: ${({ color }) => color ?? `${colors.grayDark}`};
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  width: 100%;
  margin: ${dimensions.spaces.small}px 0;

  &:nth-child(even) {
    background-color: ${colors.grayExtraLight};
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`

export const TableHead = styled.tr`
  color: ${colors.white};
  font-size: 12px;
  font-weight: 700;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;

  &:nth-child(odd) {
    border-right: 2px solid ${colors.white};
  }

  &:nth-child(even) {
    border-right: 2px solid ${colors.white};
  }

  &:last-child {
    border-right: none;
  }
`

export const THead = styled.thead`
  background-color: ${colors.blue};
  height: 44px;
  border-radius: 4px 4px 0 0;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const TBody = styled.tbody`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`

export const TableItem = styled.td<{ active?: boolean; scroll?: boolean }>`
  display: flex;
  color: ${({ active }) => (active ? `${colors.green}` : `${colors.grayDark}`)};
  flex-direction: row;
  font-size: 14px;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  width: 100%;
  flex: 1;

  overflow-y: ${({ scroll }) => (scroll ? `scroll` : `hidden`)};
  overflow-x: hidden;

  &:nth-child(odd) {
    border-right: 2px solid ${colors.white};
  }

  &:nth-child(even) {
    border-right: 2px solid ${colors.white};
  }

  &:last-child {
    border-right: none;
  }
`

export const IconButtonStyle = styled(Button)`
  color: ${colors.blue};
  width: 40px;
  height: 40px;
`
